import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type React from "react";

export default function ColumnHeader({ title, extra }: { title: string; extra?: React.ReactNode; isActive?: boolean }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Typography component="span" sx={{ fontWeight: 600, fontSize: "inherit" }}>
        {title}
      </Typography>
      {extra}
    </Box>
  );
}
